import pqGuardDogLogo from '@/assets/logo.png';
import { api } from "@/lib/api";
import { MetricsResult } from "@/types";
import { Group, Image, LoadingOverlay, Paper, Stack, Table, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";

const PrintMetrics = () => {
    const [metrics, setMetrics] = useState<MetricsResult | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        document.title = "User Metrics - Guard Dog Real Estate Protection Service";
        const getMetrics = async () => {
            try {
                const metricsResult: MetricsResult = await api.get(`/admin/metrics`);
                setMetrics(metricsResult);
            }
            catch (error) {
                console.error("Error fetching metrics:", error);
            }
            finally {
                setLoading(false);
            }
        }
        getMetrics();
    }, [])

    return (
        <>
            <LoadingOverlay visible={loading} overlayProps={{ blur: 2, radius: 'sm' }} loaderProps={{ size: 'xl' }}></LoadingOverlay>
            {!metrics && (
                <Stack justify="center" align="center" style={{ height: '100vh' }}>
                    <Text size="xl" c="dimmed">Loading metrics...</Text>
                </Stack>
            )}
            {metrics &&
                <Paper p='md' radius={'md'}>
                    <Stack align={'end'} justify={'flex-end'}>
                        <Group style={{ width: '100%' }}>
                            <Group align='center'>
                                <Image style={{ objectFit: 'contain' }} src={pqGuardDogLogo} alt='ParcelQuest Guard Dog' height={100} />
                                <Stack gap={0}>
                                    <Title style={{ textAlign: 'center', fontFamily: 'Elston, sans-serif', letterSpacing: '2px' }} order={1}>User Metrics by County{window.location.hostname.includes('guarddogqa') ? ' - QA Site' : window.location.hostname.includes('localhost') ? ' - DEV Site' : ''}</Title>
                                    <Text size="sm" c="dimmed">{new Date().toLocaleString()}</Text>
                                </Stack>
                            </Group>
                        </Group>
                        <Table striped highlightOnHover>
                            <Table.Thead>
                                <Table.Tr>
                                    <Table.Th>County</Table.Th>
                                    <Table.Th>Total Users</Table.Th>
                                    <Table.Th>New Users Last 7 Days</Table.Th>
                                    <Table.Th>New Users Last 30 Days</Table.Th>
                                    <Table.Th>Active Users Last 30 Days</Table.Th>
                                    <Table.Th>Guarded Properties</Table.Th>
                                    <Table.Th>Guarded Names</Table.Th>
                                    <Table.Th>APN Found Events</Table.Th>
                                    <Table.Th>Name Found Events</Table.Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                <Table.Tr>
                                    <Table.Td>Total</Table.Td>
                                    <Table.Td>{metrics?.totalUsers ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.totalRegisteredInLast7Days ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.totalRegisteredInLast30Days ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.activeUsersInLast30Days ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.totalApnSubscriptions ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.totalNameSubscriptions ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.totalApnEvents ?? 0}</Table.Td>
                                    <Table.Td>{metrics?.totalNameEvents ?? 0}</Table.Td>
                                </Table.Tr>
                                {metrics.counties.map((county: string) => (
                                    <Table.Tr key={county}>
                                        <Table.Td>{county}</Table.Td>
                                        <Table.Td>{metrics?.usersByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.totalRegisteredInLast7DaysByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.totalRegisteredInLast30DaysByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.activeUsersInLast30DaysByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.subscriptionsApnByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.subscriptionsNameByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.apnEventsByCounty[county] ?? 0}</Table.Td>
                                        <Table.Td>{metrics?.nameEventsByCounty[county] ?? 0}</Table.Td>
                                    </Table.Tr>
                                ))}
                            </Table.Tbody>
                        </Table>
                    </Stack>
                </Paper>
            }


        </>
    )
}
export default PrintMetrics;